import { useQuery } from '@tanstack/react-query';
import { stripeAdminApi } from '../api/stripeAdminApi';

/**
 * Comptes Stripe supervisables par l'utilisateur courant.
 * Utilisé par la page ET la Sidebar (pour masquer l'entrée si aucun compte).
 */
export const useStripeAdminAccounts = (enabled = true) =>
  useQuery({
    queryKey: ['stripe-admin', 'accounts'],
    queryFn: () => stripeAdminApi.getViewableAccounts(),
    enabled,
    staleTime: 5 * 60_000,
  });
